import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dash_board_doughnut_chart = _resolveComponent("dash-board-doughnut-chart");
  const _component_empty_chart = _resolveComponent("empty-chart");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_withDirectives(_createVNode(_component_dash_board_doughnut_chart, {
    "name-values": _ctx.nameValues,
    title: _ctx.title,
    "label-tooltip": _ctx.labelTooltip,
    "label-tooltip-plural": _ctx.labelTooltipPlural
  }, null, 8, ["name-values", "title", "label-tooltip", "label-tooltip-plural"]), [[_vShow, _ctx.nameValues?.length]])], 512), [[_vShow, _ctx.nameValues?.length]]), _withDirectives(_createVNode(_component_empty_chart, {
    loading: _ctx.loading,
    url: _ctx.big ? '/public/images/charts/Arc-Large.png' : '/public/images/charts/Arc-Small.png'
  }, null, 8, ["loading", "url"]), [[_vShow, !_ctx.nameValues?.length]])]);
}